// Auto-generated avatars (dicebear initials, seeded stock photos) do NOT count
// as a real profile photo — mirror of backend routes/onboarding.py.
export const SYSTEM_AVATAR_HOSTS = [
  'api.dicebear.com', 'ui-avatars.com', 'i.pravatar.cc',
  'images.unsplash.com', 'randomuser.me', 'avatar.vercel.sh',
];

export const isUploadedAvatar = (url) => {
  const u = String(url || '').trim();
  return !!u && !SYSTEM_AVATAR_HOSTS.some((h) => u.includes(h));
};
